import * as React from "react";
import { useEffect, useRef } from "react";

import { API_UserNotifications } from "../../../src/apidefs";
import { api } from "../api";
import { useUser } from "../state";
import { NotificationCard } from "./NotificationCard";

type NotificationsPageProps = {
  notifications: API_UserNotifications | null;
  setNotificationsCount: (count: number) => void;
};

export const NotificationsPage = ({
  notifications,
  setNotificationsCount,
}: NotificationsPageProps): JSX.Element => {
  const userState = useUser();
  const markedAsReadRef = useRef(false);

  useEffect(() => {
    if (markedAsReadRef.current) return;
    markedAsReadRef.current = true;

    const markAsRead = async () => {
      // Collab request notifications are not automatically marked as read.
      const unreadNotifications = await api.get("/api/notifications/read");

      console.log(unreadNotifications);

      if (!api.isToast(unreadNotifications)) {
        setNotificationsCount(unreadNotifications.length);
      }
    };

    markAsRead();
  }, [setNotificationsCount]);

  if (!notifications || userState.type !== "logged-in") {
    return (
      <div className="mx-auto max-w-3xl px-4 py-8">
        <h2 className="mb-6 text-2xl font-semibold text-slate-800 dark:text-white">
          Loading...
        </h2>
      </div>
    );
  }

  // Separate un-actioned collab requests from other notifications
  const pendingCollabRequests = notifications.notifications.filter(
    (n) =>
      n.notification.notification_type === "Collab Request" &&
      !n.notification.seen
  );
  const otherNotifications = notifications.notifications.filter(
    (n) =>
      !(
        n.notification.notification_type === "Collab Request" &&
        !n.notification.seen
      )
  );

  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <h2 className="mb-6 text-2xl font-semibold text-slate-800 dark:text-white">
        Notifications
      </h2>

      {pendingCollabRequests.length > 0 && (
        <>
          <div className="space-y-4">
            {pendingCollabRequests.map(
              (
                notification: API_UserNotifications["notifications"][number]
              ) => (
                <NotificationCard
                  key={`${notification.notification.id}-${notification.notification.created}`}
                  notification={notification}
                  onCardAcknowledge={() => {}}
                />
              )
            )}
          </div>
          <div className="my-6 border-t border-slate-200 dark:border-slate-700" />
        </>
      )}

      <div className="space-y-4">
        {otherNotifications.map(
          (notification: API_UserNotifications["notifications"][number]) => (
            <NotificationCard
              key={`${notification.notification.id}-${notification.notification.created}`}
              notification={notification}
              onCardAcknowledge={() => {}}
            />
          )
        )}
      </div>
    </div>
  );
};
